import { Grid } from "@mui/material";
import Card from "@mui/material/Card";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useCardroomContext } from "features";
import { Formik, Form, ErrorMessage } from 'formik';
import { useState } from "react";

import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import { useEffect } from "react";
import FormField from "components/Elements/Forms/FormField";
import CardroomSecurityEditor from "../CardroomSecurity";
import CardroomSubscriptionEditor from "../CardroomSubscription";
import ClubFeesEditor from "../ClubFees";
import UnionDefaultsEditor from "../UnionDefaults";
import ReferralFeesSettingsEditor from "../Referrals";
import SoftAvatar from "components/SoftAvatar";

import { apiConfig } from 'config/apiConfig'
import FormImageField from "components/Elements/Forms/FormImageField";
import SoftButton from "components/SoftButton";
import { useProgressIndicator } from "components/Elements/ProgressIndicator";
import { ProgressIndicator } from "components/Elements/ProgressIndicator";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import AdaptiveTab from "components/Elements/AdaptiveTab";
import PlayerRebateEditor from "../PlayerRebates";
import PremiumServiceSubscriptionRequired from "components/Elements/PremiumServiceRequried";
import CurrencySettingsEditor from "../CurrencySettings";
import UnionFeesEditor from "../UnionFees";
import FeeTierScheduleSettingsEditor from "../FeeTierScheduleSettingsEditor";
import CardroomNotificationGroupEditor from "features/NotificationGroups";




const CardroomEditorForm = ({ cardroom, club, union, agency, book, readonly, formData }) => {

    const { formField, values, errors, touched, setFieldValue, setFieldError, setFieldTouched, validateForm, resetForm } = formData;
    const { cardroomId, name, logo, phoneNumber, smsNumber, smsVanityNumber, type, emailAddress } = formField;

    const { cardroomId: cardroomIdV,
        name: nameV,
        logo: logoV,
        phoneNumber: phoneNumberV,
        smsNumber: smsNumberV,
        smsVanityNumber: smsVanityNumberV,
        type: typeV,
        emailAddress: emailAddressV
    } = values;

    const [formDataInitialized, setFormDataInitialized] = useState(false);

    const [context, actions, features] = useCardroomContext(cardroom);

    useEffect(() => {
        setFormDataInitialized(false);
    }, [cardroom]);

    useEffect(() => {
        if (!formDataInitialized) {

            resetForm();

            setFieldValue(cardroomId.name, cardroom.id);
            setFieldValue(name.name, cardroom.name);
            // setFieldValue(name.name, pn);
            // setFieldValue(phoneNumber.name, phone);
            setFieldValue(type.name, cardroom.type);
            setFieldValue(emailAddress.name, cardroom.emailAddress ? cardroom.emailAddress : "");
            setFieldValue(phoneNumber.name, cardroom.phoneNumber ? cardroom.phoneNumber : "");
            setFieldValue(smsNumber.name, cardroom.smsNumber ? cardroom.smsNumber : "");
            setFieldValue(smsVanityNumber.name, cardroom.vanitySmsNumber ? cardroom.vanitySmsNumber : "");

            if (cardroom && cardroom.hasLogo) {
                setFieldValue(logo.name, apiConfig.images.endpoint + "/casino/" + cardroom.id + ".png");
            }

            setFormDataInitialized(true);
        }
    }, [formDataInitialized]);

    function getCasinoTypeName() {
        if (!cardroom) return null;
        switch (cardroom.type) {
            case 1:
                return "Home Game";
            case 2:
                return "Online Club";
            case 3:
                return "Online Union";
            case 4:
                return "Stacking Stable";
            case 5:
                return "Online Agency";
            case 6:
                return "Online Book";
        }

        return "N/A";
    }
    function getOnlineObjectType() {
        if (!cardroom || cardroom.type === 1 || cardroom.type === 4) return null;

        switch (cardroom.type) {
            case 2:
                return "Club";
            case 3:
                return "Union";
            case 5:
                return "Agency";
            case 6:
                return "Book";
        }

        return "N/A";
    }

    function getOnlinePlatformName() {
        if (!cardroom || cardroom.type === 1 || cardroom.type === 4) return null;

        let app = null;
        if (cardroom.type === 2 && club != null) {
            app = club.app;
        }
        else if (cardroom.type === 3 && union != null) {
            app = union.app;
        }
        else if (cardroom.type === 5 && agency != null) {
            app = agency.app;
        }
        else if (cardroom.type === 6 && book != null) {
            app = book.app;
        }

        if (app) return app.name;

        return "Unknown";
    }

    function getOnlineObjectId() {
        if (!cardroom || cardroom.type === 1 || cardroom.type === 4) return null;

        if ((cardroom.type === 2 || cardroom.type === 6) && club != null) {
            return club.appClubId;
        }
        else if (cardroom.type === 3 && union != null) {
            return union.appUnionId;
        }
        else if (cardroom.type === 5 && agency != null) {
            return agency.appAgentId;
        }

        return "Unknown";
    }

    function canEditEmail() {
        if (false === canEditCardroom()) return false;

        return !(cardroom.type === 2 || cardroom.type === 3 || cardroom.type === 5 || cardroom.type === 6);
    }

    function canEditCardroom() {

        if (!cardroom) return false;
        if (!context) return false;

        return context.isAllowed(actions.cardroom.properties.edit);
    }



    function getPlayerImagePresenter({ src }) {

        return <SoftAvatar src={src} size="xxl" variant="rounded" bgColor="light" />
    }

    return <Grid container spacing={1}>
        <Grid item xs={12} sm={4} container justifyContent="center">
            <SoftBox position="relative" height="max-content" mx="auto">
                {canEditCardroom() ?
                    <FormImageField name={logo.name} caption="Drop casino logo here" imgHeight={120} imagePresenter={getPlayerImagePresenter}  {...formData} />
                    : <SoftAvatar src={logoV} size="xxl" variant="rounded" bgColor="dark" />}
            </SoftBox>
        </Grid>
        <Grid xs={12} sm={8}>
            <Grid xs={12} container >
                <Grid item xs={4} >
                    <SoftBox mb={1} mt={0} ml={0.5} lineHeight={0} display="inline-block" >
                        <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize">
                            Type
                        </SoftTypography>
                    </SoftBox>
                </Grid>
                <Grid item xs={8}>
                    <SoftBox mb={1} mt={0} ml={0.5} lineHeight={0} display="inline-block">
                        <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                        >
                            {getCasinoTypeName()}
                        </SoftTypography>
                    </SoftBox>
                </Grid>
            </Grid>

            <Grid xs={12} container>
                <Grid item xs={4} >
                    <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                        <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize">
                            {name.label}
                        </SoftTypography>
                    </SoftBox>
                </Grid>
                <Grid item xs={8}>
                    <FormField disabled={readonly || !canEditCardroom()}
                        type={name.type}
                        name={name.name}
                        value={nameV}
                        placeholder={name.placeholder}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
            </Grid>

            {typeV === 1 ? <>
                <Grid xs={12} container>
                    <Grid item xs={4} >
                        <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize">
                                {phoneNumber.label}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={8}>
                        <FormField disabled={readonly}
                            type={phoneNumber.type}
                            name={phoneNumber.name}
                            value={phoneNumberV}
                            placeholder={phoneNumber.placeholder}
                            error={errors.phoneNumber && touched.phoneNumber}
                            success={phoneNumberV && phoneNumberV.length > 0 && !errors.phoneNumber}
                        />
                    </Grid>
                </Grid>

                <Grid xs={12} container>
                    <Grid item xs={4} >
                        <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize">
                                {smsNumber.label}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={8}>
                        <FormField disabled={readonly}
                            type={smsNumber.type}
                            name={smsNumber.name}
                            value={smsNumberV}
                            placeholder={smsNumber.placeholder}
                            error={errors.smsNumber && touched.smsNumber}
                            success={smsNumberV && smsNumberV.length > 0 && !errors.smsNumber}
                        />
                    </Grid>
                </Grid>

                <Grid xs={12} container>
                    <Grid item xs={4} >
                        <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize">
                                {smsVanityNumber.label}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={8}>
                        <FormField disabled={readonly}
                            type={smsVanityNumber.type}
                            name={smsVanityNumber.name}
                            value={smsVanityNumberV}
                            placeholder={smsVanityNumber.placeholder}
                            error={errors.smsVanityNumber && touched.smsVanityNumber}
                            success={smsVanityNumberV && smsVanityNumberV.length > 0 && !errors.smsVanityNumber}
                        />
                    </Grid>
                </Grid></> : null}

            {typeV === 2 || typeV === 3 || typeV === 5 ? <>
                <Grid xs={12} container>
                    <Grid item xs={4} >
                        <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize">
                                Online Platform
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={8}>
                        <SoftBox mb={1} mt={0} ml={0.5} lineHeight={0} display="inline-block">
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                            >
                                {getOnlinePlatformName()}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
                <Grid xs={12} container>
                    <Grid item xs={4} >
                        <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize">
                                {getOnlinePlatformName()} {getOnlineObjectType()} ID
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={8}>
                        <SoftBox mb={1} mt={0} ml={0.5} lineHeight={0} display="inline-block">
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                            >
                                {getOnlineObjectId()}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
            </> : null}

            <Grid xs={12} container>
                <Grid item xs={4} >
                    <SoftBox mb={1} mt={1.25} ml={0.5} lineHeight={0} display="inline-block" >
                        <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize">
                            {emailAddress.label}
                        </SoftTypography>
                    </SoftBox>
                </Grid>
                <Grid item xs={8}>
                    <FormField disabled={readonly || !canEditEmail()}
                        type={emailAddress.type}
                        name={emailAddress.name}
                        value={emailAddressV}
                        placeholder={emailAddress.placeholder}
                        error={errors.emailAddress && touched.emailAddress}
                        success={emailAddressV && emailAddressV.length > 0 && !errors.emailAddress}
                    />
                </Grid>
            </Grid>
        </Grid>
    </Grid>;
};

const CardroomProfileEditor = ({ cardroom, club, union, agency, onCardroomChanged }) => {

    const { formId, formField } = form;
    const currentValidation = validations.editor;

    const [pendingCasinoLogo, setPendingCasinoLogo] = useState(null);
    const [pendingCasino, setPendingCasino] = useState(null);


    const [retryCounter, setRetryCounter] = useState(0);

    function handleRetry() {
        setRetryCounter(retryCounter + 1);
    }
    const [showProgress, progressIndicatorProps] = useProgressIndicator("wait", "saving cardroom...", handleRetry)

    const { error, execute } = useFetchWithMsal({
        scopes: apiConfig.casino.scopes.write,
    });

    function raiseOnChanged() {
        if (onCardroomChanged) {
            onCardroomChanged();
        }
    }

    const handleSubmit = (values, actions) => {
        var updatedCardroom = {};
        updatedCardroom.id = cardroom.id;
        updatedCardroom.type = cardroom.type;
        updatedCardroom.hasLogo = cardroom.hasLogo;

        updatedCardroom.name = values.name;
        updatedCardroom.phoneNumber = values.phoneNumber;
        updatedCardroom.smsNumber = values.smsNumber;
        updatedCardroom.vanitySmsNumber = values.smsVanityNumber;

        if (!(cardroom.type === 2 || cardroom.type === 3 || cardroom.type === 6)) {
            updatedCardroom.emailAddress = values.emailAddress;
        }

        if (values.logo) {
            //check if log is pointing at url or data:image/
            //if so, set update logo request
            if (values.logo.startsWith("data:image/")) {
                updatedCardroom.hasLogo = true;
                setPendingCasinoLogo(values.logo);
            }
        }
        else {
            updatedCardroom.hasLogo = false;
        }

        setPendingCasino(updatedCardroom);
    };


    useEffect(() => {
        if (pendingCasinoLogo) {
            // [HttpPut("{casinoId:Guid}/logo", Name = "SetCasinoLogo")]
            execute("PUT", apiConfig.casino.endpoint + "/" + cardroom.id + "/logo", pendingCasinoLogo).then((response) => {
                if (response) {
                    cardroom.hasLogo = false;
                    cardroom.hasLogo = true;
                }
                //clear payload and close dialog...
                // setTransactionSavePayload(null);
                // progressIndicatorProps.close();

                setPendingCasinoLogo(null);

            }).catch((e) => {
                //progressIndicatorProps.setMode("errorWithRetry");
                //progressIndicatorProps.setMessage("Unable to save transaction, please try again...")
            });
        }

    }, [pendingCasinoLogo, execute]);

    useEffect(() => {
        if (pendingCasino && !pendingCasinoLogo) {

            progressIndicatorProps.setMode("wait");
            progressIndicatorProps.setMessage("Saving cardroom profile...")
            showProgress();

            // [HttpPost("", Name = "SaveCasino")]
            execute("POST", apiConfig.casino.endpoint + "/", pendingCasino).then((response) => {
                if (response) {
                    //raiseOnTransactionCreated();
                    cardroom = Object.assign(cardroom, response);
                }

                raiseOnChanged();
                setPendingCasino(null);
                progressIndicatorProps.close();
                //raiseOnClose();

            }).catch((e) => {
                progressIndicatorProps.setMode("errorWithRetry");
                progressIndicatorProps.setMessage("Unable to save cardroom profile, please try again...")
            });
        }

    }, [pendingCasino, pendingCasinoLogo, execute, retryCounter]);


    const cancelEdit = () => { };

    const [context, actions, features] = useCardroomContext(cardroom);
    function canEditCardroom() {
        if (!cardroom) return false;
        if (!context) return false;

        return context.isAllowed(actions.cardroom.properties.edit);
    }

    return (<Card id="basic-info" sx={{ overflow: "visible" }}>
        {cardroom ?
            <SoftBox p={3}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={currentValidation}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, setFieldValue, setFieldError, setFieldTouched, validateForm, resetForm, isSubmitting }) => {
                        return <Form id={formId} autoComplete="off">

                            <SoftBox p={2} >
                                <SoftBox >
                                    <ProgressIndicator {...progressIndicatorProps} />

                                    {progressIndicatorProps.visible ? <></> : <>

                                        <CardroomEditorForm cardroom={cardroom} club={club} union={union} agency={agency} readonly={!canEditCardroom()} formData={{
                                            values,
                                            touched,
                                            formField,
                                            errors,
                                            setFieldValue,
                                            setFieldError,
                                            setFieldTouched,
                                            validateForm,
                                            resetForm
                                        }} />


                                        <SoftBox mt={3} width="100%" display="flex" justifyContent="space-between">

                                            <SoftButton variant="gradient" color="light" onClick={cancelEdit}>
                                                cancel
                                            </SoftButton>


                                            <SoftButton
                                                variant="gradient"
                                                color="dark"
                                                disabled={isSubmitting || !canEditCardroom()}
                                                type="submit"
                                            >
                                                save
                                            </SoftButton>
                                        </SoftBox>
                                    </>}
                                </SoftBox>
                            </SoftBox>
                        </Form>
                    }}
                </Formik>
            </SoftBox>
            : null}

    </Card>);
};

const OnlineBookCardroomProfile = ({ cardroom, club, onCardroomChanged }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function isAgentFeeScheduleEnabled() {
        if (!context) return false;
        if (!club) return false;

        return context.isEnabled(features.club.reporting.agentReport);
    }

    function canEditAgentFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    function isPlayerFeeScheduleEnabled() {
        if (!context) return false;
        if (!club) return false;

        return context.isEnabled(features.club.reporting.playerReport);
    }

    function canEditPlayerFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.rebate.edit);
    }

    function isCurencyConversionEnabled() {
        if (!context) return false;

        return context.isEnabled(features.currency.conversion);
    }

    function canManageCurrencies() {
        if (!context) return false;
        if (!club) return false;

        return context.isAllowed(actions.cardroom.currency.manage);
    }

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} club={club} union={null} agency={null} onCardroomChanged={onCardroomChanged} />
    });

    if (canEditAgentFeeSchedules()) {
        tabs.push({
            title: { text: "Agent Fees", icon: "percent" },
            header: null,
            body: isAgentFeeScheduleEnabled() ? <>Coming soon...</> : <PremiumServiceSubscriptionRequired service="Agent Fee Schedules" />
        });
    }

    if (canEditPlayerFeeSchedules()) {
        tabs.push({
            title: { text: "Player Rebates", icon: "price_check" },
            header: null,
            body: isPlayerFeeScheduleEnabled() ? <PlayerRebateEditor cardroom={cardroom} agency={null} club={club} /> : <PremiumServiceSubscriptionRequired service="Player Rebate Schedules" />
        });
    }

    if (canManageCurrencies()) {
        tabs.push({
            title: { text: "Currencies", icon: "currency_exchange" },
            header: null,
            body: isCurencyConversionEnabled() ? <CurrencySettingsEditor cardroom={cardroom} agency={null} club={club} union={null} /> : <PremiumServiceSubscriptionRequired service="Currency Exchange" />
        });
    }

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });


    tabs.push({
        title: { text: "Subscription", icon: "subscriptions" },
        header: null,
        body: <CardroomSubscriptionEditor cardroom={cardroom} />
    });

    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
}

const OnlineAgencyCardroomProfile = ({ cardroom, agency, onCardroomChanged }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function isAgentFeeScheduleEnabled() {
        if (!context) return false;
        if (!agency) return false;

        return context.isEnabled(features.club.reporting.agentReport);
    }

    function canEditAgentFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    function isPlayerFeeScheduleEnabled() {
        if (!context) return false;
        if (!agency) return false;

        return context.isEnabled(features.club.reporting.playerReport);
    }

    function canEditPlayerFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.rebate.edit);
    }

    function isCurencyConversionEnabled() {
        if (!context) return false;

        return context.isEnabled(features.currency.conversion);
    }

    function canManageCurrencies() {
        if (!context) return false;
        if (!agency) return false;

        return context.isAllowed(actions.cardroom.currency.manage);
    }

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} club={null} union={null} agency={agency} onCardroomChanged={onCardroomChanged} />
    });

    if (canEditAgentFeeSchedules()) {
        tabs.push({
            title: { text: "Agent Fees", icon: "percent" },
            header: null,
            body: isAgentFeeScheduleEnabled() ? <>Coming soon...</> : <PremiumServiceSubscriptionRequired service="Agent Fee Schedules" />
        });
    }

    if (canEditPlayerFeeSchedules()) {
        tabs.push({
            title: { text: "Player Rebates", icon: "price_check" },
            header: null,
            body: isPlayerFeeScheduleEnabled() ? <PlayerRebateEditor cardroom={cardroom} agency={agency} club={null} /> : <PremiumServiceSubscriptionRequired service="Player Rebate Schedules" />
        });
    }

    if (canManageCurrencies()) {
        tabs.push({
            title: { text: "Currencies", icon: "currency_exchange" },
            header: null,
            body: isCurencyConversionEnabled() ? <CurrencySettingsEditor cardroom={cardroom} agency={agency} club={null} union={null} /> : <PremiumServiceSubscriptionRequired service="Currency Exchange" />
        });
    }

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });


    tabs.push({
        title: { text: "Subscription", icon: "subscriptions" },
        header: null,
        body: <CardroomSubscriptionEditor cardroom={cardroom} />
    });

    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
}

const OnlineClubCardroomProfile = ({ cardroom, club, onCardroomChanged }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function isAgentFeeScheduleEnabled() {
        if (!context) return false;
        if (!club) return false;

        return context.isEnabled(features.club.reporting.agentReport);
    }

    function canEditAgentFeeSchedules() {
        if (!context) return false;
        if (!club) return false;

        return context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    function isPlayerFeeScheduleEnabled() {
        if (!context) return false;
        if (!club) return false;

        return context.isEnabled(features.club.reporting.playerReport);
    }

    function canEditPlayerFeeSchedules() {
        if (!context) return false;
        if (!club) return false;

        return context.isAllowed(actions.cardroom.fees.rebate.edit);
    }

    function isCurencyConversionEnabled() {
        if (!context) return false;

        return context.isEnabled(features.currency.conversion);
    }

    function canManageCurrencies() {
        if (!context) return false;
        if (!club) return false;

        return context.isAllowed(actions.cardroom.currency.manage);
    }

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} club={club} union={null} onCardroomChanged={onCardroomChanged} />
    });

    if (canEditAgentFeeSchedules()) {
        tabs.push({
            title: { text: "Agent Fees", icon: "percent" },
            header: null,
            body: isAgentFeeScheduleEnabled() ? <ClubFeesEditor cardroom={cardroom} club={club} /> : <PremiumServiceSubscriptionRequired service="Agent Fee Schedules" />
        });
    }

    if (canEditPlayerFeeSchedules()) {
        tabs.push({
            title: { text: "Player Rebates", icon: "price_check" },
            header: null,
            body: isPlayerFeeScheduleEnabled() ? <PlayerRebateEditor cardroom={cardroom} club={club} agency={null} /> : <PremiumServiceSubscriptionRequired service="Player Rebate Schedules" />
        });
    }

    if (canManageCurrencies()) {
        tabs.push({
            title: { text: "Currencies", icon: "currency_exchange" },
            header: null,
            body: isCurencyConversionEnabled() ? <CurrencySettingsEditor cardroom={cardroom} agency={null} club={club} union={null} /> : <PremiumServiceSubscriptionRequired service="Currency Exchange" />
        });
    }

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });


    tabs.push({
        title: { text: "Subscription", icon: "subscriptions" },
        header: null,
        body: <CardroomSubscriptionEditor cardroom={cardroom} />
    });

    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
}

const OnlineUnionCardroomProfile = ({ cardroom, union, onCardroomChanged }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function canEditReferralSchedules() {
        //if (!context) return false;

        if (!union) return false;

        // if (union.isVirtual) return false;

        // ReferralScheduleEdit = 4,
        if ((union.features & 4) === 0) return false;

        return true;
    }

    function canEditFeeSchedules() {
        //if (!context) return false;

        if (!union) return false;

        //if (union.isVirtual) return false;

        //  ClubFeeScheduleEdit = 1,
        if ((union.features & 1) === 0) return false;

        return true;
    }

    function canSetDefaults() {
        if (!union) return false;

        //if (union.isVirtual) return false;

        return true;
    }

    function canEditNotificationGroups() {
        if (!context) return false;

        return true;
    }

    function isCurencyConversionEnabled() {
        if (!context) return false;

        return context.isEnabled(features.currency.conversion);
    }

    function canManageCurrencies() {
        if (!context) return false;
        if (null == union) return false;

        return context.isAllowed(actions.cardroom.currency.manage);
    }

    function isFeeTiersFeatureEnabled() {
        return true;
    }

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} club={null} union={union} onCardroomChanged={onCardroomChanged} />
    });

    if (canEditFeeSchedules()) {
        tabs.push({
            title: { text: "Club Fees", icon: "credit_score" },
            header: null,
            body: <UnionFeesEditor cardroom={cardroom} union={union} />
        });
    }

    if (isFeeTiersFeatureEnabled()) {
        tabs.push({
            title: { text: "Fee Tiers", icon: "stairs" },
            header: null,
            body: <FeeTierScheduleSettingsEditor cardroom={cardroom} union={union} />
        });
    }

    if (canEditReferralSchedules()) {
        tabs.push({
            title: { text: "Referral Fees", icon: "recommend" },
            header: null,
            body: <ReferralFeesSettingsEditor cardroom={cardroom} union={union} />
        });
    }

    if (canSetDefaults()) {
        tabs.push({
            title: { text: "Defaults", icon: "settings_suggest" },
            header: null,
            body: <UnionDefaultsEditor cardroom={cardroom} union={union} dense={true} />
        });
    }

    if (canManageCurrencies()) {
        tabs.push({
            title: { text: "Currencies", icon: "currency_exchange" },
            header: null,
            body: isCurencyConversionEnabled() ? <CurrencySettingsEditor cardroom={cardroom} agency={null} club={null} union={union} /> : <PremiumServiceSubscriptionRequired service="Currency Exchange" />
        });
    }

    if (canEditNotificationGroups()) {
        tabs.push({
            title: { text: "Groups", icon: "comment" },
            header: null,
            body: <CardroomNotificationGroupEditor cardroom={cardroom} />
        });
    }

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });

    /*
        tabs.push({
            title: { text: "Subscription", icon: "subscriptions" },
            header: null,
            body: <CardroomSubscriptionEditor cardroom={cardroom} />
        });
    */
    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
}

const SportsBookCardroomProfile = ({ cardroom, book, onCardroomChanged }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function isAgentFeeScheduleEnabled() {
        if (!context) return false;
        if (!book) return false;

        return context.isEnabled(features.club.reporting.agentReport);
    }

    function canEditAgentFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    function isPlayerFeeScheduleEnabled() {
        if (!context) return false;
        if (!book) return false;

        return context.isEnabled(features.club.reporting.playerReport);
    }

    function canEditPlayerFeeSchedules() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.rebate.edit);
    }

    function isReferralScheduleEnabled() {
        if (!context) return false;
        if (!book) return false;

        return true; //context.isEnabled(features.club.reporting.agentReport);
    }

    function canEditReferralSchedules() {
        if (!context) return false;

        return true; //context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    function isCurencyConversionEnabled() {
        if (!context) return false;

        return context.isEnabled(features.currency.conversion);
    }

    function canManageCurrencies() {
        if (!context) return false;
        if (!book) return false;

        return context.isAllowed(actions.cardroom.currency.manage);
    }

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} book={book} club={null} union={null} agency={null} onCardroomChanged={onCardroomChanged} />
    });

    if (canEditAgentFeeSchedules()) {
        tabs.push({
            title: { text: "Agent Fees", icon: "percent" },
            header: null,
            body: isAgentFeeScheduleEnabled() ? <ClubFeesEditor cardroom={cardroom} book={book} /> : <PremiumServiceSubscriptionRequired service="Agent Fee Schedules" />
        });
    }

    if (canEditPlayerFeeSchedules()) {
        tabs.push({
            title: { text: "Player Rebates", icon: "price_check" },
            header: null,
            body: isPlayerFeeScheduleEnabled() ? <PlayerRebateEditor cardroom={cardroom} agency={null} club={null} book={book} /> : <PremiumServiceSubscriptionRequired service="Player Rebate Schedules" />
        });
    }

    if (canEditReferralSchedules()) {
        tabs.push({
            title: { text: "Referral Fees", icon: "recommend" },
            header: null,
            body: isReferralScheduleEnabled() ? <ReferralFeesSettingsEditor cardroom={cardroom} book={book} /> : <PremiumServiceSubscriptionRequired service="Player Referral Schedules" />
        });
    }

    if (canManageCurrencies()) {
        tabs.push({
            title: { text: "Currencies", icon: "currency_exchange" },
            header: null,
            body: isCurencyConversionEnabled() ? <CurrencySettingsEditor cardroom={cardroom} agency={null} club={null} union={null} book={book} /> : <PremiumServiceSubscriptionRequired service="Currency Exchange" />
        });
    }

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });


    tabs.push({
        title: { text: "Subscription", icon: "subscriptions" },
        header: null,
        body: <CardroomSubscriptionEditor cardroom={cardroom} />
    });

    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
}

const BNMCardroomProfile = ({ cardroom, onCardroomChanged }) => {

    const tabs = [];

    tabs.push({
        title: { text: "Properties", icon: "contact_phone" },
        header: null,
        body: <CardroomProfileEditor cardroom={cardroom} club={null} union={null} agency={null} onCardroomChanged={onCardroomChanged} />
    });

    tabs.push({
        title: { text: "Security", icon: "security" },
        header: null,
        body: <CardroomSecurityEditor cardroom={cardroom} />
    });


    tabs.push({
        title: { text: "Subscription", icon: "subscriptions" },
        header: null,
        body: <CardroomSubscriptionEditor cardroom={cardroom} />
    });

    return cardroom ? <SoftBox pt={2}><AdaptiveTab switchToMobileOnSize="lg" tabs={tabs} /></SoftBox> : null;
};

const CardroomProfile = ({ cardroom, club, union, agency, book, onCardroomChanged }) => {

    return <Grid sx={{ overflow: "visible" }} width="100%" minHeight={375}>
        {cardroom ? <>
            {cardroom.type === 1 ? <BNMCardroomProfile cardroom={cardroom} onCardroomChanged={onCardroomChanged} /> : null}
            {cardroom.type === 2 ? <OnlineClubCardroomProfile cardroom={cardroom} club={club} onCardroomChanged={onCardroomChanged} /> : null}
            {cardroom.type === 3 ? <OnlineUnionCardroomProfile cardroom={cardroom} union={union} onCardroomChanged={onCardroomChanged} /> : null}
            {cardroom.type === 5 ? <OnlineAgencyCardroomProfile cardroom={cardroom} agency={agency} onCardroomChanged={onCardroomChanged} /> : null}
            {cardroom.type === 6 ? <SportsBookCardroomProfile cardroom={cardroom} book={book} onCardroomChanged={onCardroomChanged} /> : null}
        </> : null}
    </Grid>

};

export default CardroomProfile;